import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { Grid } from "@shared/components/pagination/codebase/suite";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ServiciosService } from "../servicios.service";
import { Mensaje } from "../../../shared/components/mensajes/mensaje.modelo";
import { catchError, concatMap, takeUntil, toArray } from "rxjs/operators";
import { from, of, Subject } from "rxjs";

@Component({
  selector: "app-popup-configuracioncapasxmapa",
  templateUrl: "./popup-configuracioncapasxmapa.component.html",
  styleUrls: ["./popup-configuracioncapasxmapa.component.scss"],
})
export class PopupConfiguracionCapasxMapaComponent implements OnInit {
  gridConfigCapasxMapa: Grid;
  modalRef: any;
  mensaje: Mensaje;
  row: any;
  idVisorPublico: string = "MAP_LEAFLET_VISOR_PUBLICO"
  private unsubscribe$: Subject<void> = new Subject<void>();
  sistema: string;
  array: any = [];
  capasEditadas: any = [];

  @ViewChild("configuracioncapasxmapa", { static: true }) containerConfiguracioncapasxmapa: ElementRef;

  constructor(
    private modalService: NgbModal,
    private servicios: ServiciosService
  ) {
    this.mensaje = new Mensaje("", "", "");
  }

  ngOnInit(): void {
    let clase = this;
    this.sistema = sessionStorage.getItem("sistemaLogueado");
    this.gridConfigCapasxMapa = new Grid(this.containerConfiguracioncapasxmapa.nativeElement, {
      css: "dhx_demo-grid",
      columns: [
        {
          minWidth: 170,
          id: "cap_nombre",
          header: [{ text: "Nombre capa", align: "center" }, { content: "inputFilter" }],
          align: "center",
          editable: false,
          resizable: true,
        },
        {
          minWidth: 50,
          id: "cap_asociar",
          header: [{ text: "Asociar", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "boolean",
        },
        {
          minWidth: 50,
          id: "cap_activa",
          header: [{ text: "Activa", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "boolean",
        },
        {
          minWidth: 50,
          id: "cap_transp",
          header: [{ text: "Transparencia", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "number"
        },
        {
          minWidth: 50,
          id: "cap_orden",
          header: [{ text: "Orden", align: "center" }, { content: "inputFilter" }],
          align: "center",
          type: "number"
        }
      ],
      adjust: false,
      autoWidth: true,
      editable: true,
    });

    this.gridConfigCapasxMapa.events.on("afterEditEnd", function (value, row, column) {
      const index = clase.capasEditadas.findIndex((_row) => _row.cap_codigo === row.cap_codigo);
      if (index >= 0) {
        clase.capasEditadas[index] = row;
      } else {
        clase.capasEditadas.push(row);
      }
    });

    this.ObtenerCapasMapa();
  }

  /**
   * Obtiene las capas asociadas al mapa seleccionado
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  ObtenerCapasMapa() {
    try {
      this.servicios
        .getCapasMapa(this.row)
        .subscribe((respuesta) => {
          if (respuesta.state == "success") {
            this.array = [];
            respuesta.result.forEach(capa => {
              this.array.push({
                cap_codigo: capa.cap_codigo,
                map_codigo: capa.map_codigo,
                cap_nombre: capa.cap_alias,
                cap_alias: capa.cap_alias,
                map_nombre: capa.map_nombre,
                cap_asociar: true,
                cap_activa: capa.cxm_json.cap_activa,
                cap_transp: capa.cxm_json.cap_transp,
                cap_orden: capa.cxm_json.cap_orden
              });
            });
            this.array.sort((a, b) => {
              if (a.cap_orden == null) return 1;
              if (b.cap_orden == null) return -1;
              return a.cap_orden - b.cap_orden;
            });
            this.gridConfigCapasxMapa.data.parse(this.array);
          }
        });
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al consultar el servicio, por favor validar",
        ""
      );
    }
  }

  /**
   * Se realiza la petición para editar la configuración de las capas
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  EditarConfigCapa(capa) {
    const entrada = {
      cap_codigo: capa.cap_codigo,
      map_codigo: capa.map_codigo,
      sis_codigo: this.sistema,
      cap_alias: capa.cap_alias,
      map_nombre: capa.map_nombre,
      cxm_json: {
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      }
    };
    try {
      return this.servicios.EditarCapaxMapa(JSON.stringify(entrada));
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al guardar la configuración de la capa",
        ""
      );
    }
  }

  /**
   * Se realiza la petición para eliminar una capa de un mapa
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  EliminarCapaxMapa(capa) {
    const entrada = {
      cap_codigo: capa.cap_codigo,
      map_codigo: capa.map_codigo,
      sis_codigo: this.sistema,
      cap_alias: capa.cap_alias,
      map_nombre: capa.map_nombre,
      cxm_json: {
        cap_activa: capa.cap_activa,
        cap_transp: capa.cap_transp,
        cap_orden: capa.cap_orden
      }
    };
    try {
      const index = this.array.findIndex((_capa) => _capa.cap_codigo === capa.cap_codigo);
      if (index >= 0) {
        this.array.splice(index, 1);
      }
      return this.servicios.EliminarCapaxMapa(JSON.stringify(entrada));
    } catch (error) {
      this.mensaje.retornarMensaje(
        "error",
        "Atención",
        "Error al guardar la configuración de la capa",
        ""
      );
    }
  }

  /**
   * Se validan los registros editados para guardar la información
   * @author Elisabeth Campuzano
   * @date 15/09/2025
   * @param
   * @returns
   */
  AccionGuardar() {
    const peticiones: any[] = [];
    this.capasEditadas.forEach((capa) => {
      if (capa.cap_asociar === true){
        peticiones.push(this.EditarConfigCapa(capa));
      }
      else{
        peticiones.push(this.EliminarCapaxMapa(capa));
      }
    });

    const _request = from(peticiones).pipe(
      concatMap((req) => req.pipe(catchError((error) => of({ respuesta: 'false', error })))),
      toArray()
    );

    _request.subscribe((result) => {
      let conError = 0;
      let conExito = 0;
      result.forEach((element) => {
        if (element['state'] === 'success') {
          conExito++;
        } else {
          conError++;
        }
      });
      if (conError === 0) {
        this.mensaje.retornarMensajeFuncion(
          'confirmacionok',
          'La información fue actualizada con Éxito',
          '',
          '',
          () => {
          },
          '',
          null
        );
        this.array.sort((a, b) => {
          if (a.cap_orden == null) return 1;
          if (b.cap_orden == null) return -1;
          return a.cap_orden - b.cap_orden;
        });
        this.gridConfigCapasxMapa.data.parse(this.array);
      } else if (conExito === 0) {
        this.mensaje.retornarMensaje('error', 'Atención', 'Ocurrió un error! Por favor valide nuevamente', '');
      } else {
        this.mensaje.retornarMensajeFuncion(
          'confirmacionerror',
          'Se actualizaron ' + conExito + ' registros con exito y ' + conError + ' tuvieron error',
          '',
          '',
          () => {
          },
          '',
          null
        );
      }
    });
    this.capasEditadas = [];
  }

  ConfirmadoAccionGuardar(contenedor) {
    contenedor.AccionGuardar();
  }

  CancelarAccionURL(contenedor) {
    contenedor.capasEditadas = [];
    contenedor.modalService.dismissAll();
  }

  ngOnDestroy() {
    if (this.gridConfigCapasxMapa) {
      this.gridConfigCapasxMapa.destructor();
    }
  }

  CerrarModal() {
    if (this.capasEditadas.length > 0) {
      this.mensaje.retornarMensajeFuncion2(
        'confirmacion',
        'No ha almacenado los cambios realizados, ¿Desea guardarlos?',
        '',
        this,
        'ConfirmadoAccionGuardar',
        this,
        'CancelarAccionURL'
      );
    }
    else {
      this.modalService.dismissAll();
    }
  }
}
